import { browserFastApiClient, requireFastApiAccessToken } from "@/core/fastapi";
import {
  areThoughtsReflectedApiService,
  type SelectedProfileInput,
} from "@/generated/fastapi";

export async function areThoughtsReflected(
  accessToken: string | null | undefined,
  selectedProfile: SelectedProfileInput,
): Promise<boolean> {
  const response = await areThoughtsReflectedApiService({
    client: browserFastApiClient,
    auth: requireFastApiAccessToken(accessToken),
    body: {
      selected_profile: selectedProfile,
    } as never,
  });

  if (response.status !== 200) {
    throw new Error(
      `Failed to check if thoughts are reflected (${response.status})`,
    );
  }

  return response.data?.all_reflected ?? false;
}
